export default "__VITE_ASSET__C007Ht_n__"